import { useRecoilValue } from "recoil";
import { deviceCarriersState } from "../storage/devices";
import { useCallback } from "react";

export function useDevice() {
  const deviceCarriers = useRecoilValue(deviceCarriersState);

  const getDeviceCarrierLabel = useCallback(
    (slug: string) => {
      const carrier = deviceCarriers?.find((s) => slug === s.slug);
      if (carrier) {
        return carrier.label;
      }
      return slug;
    },
    [deviceCarriers]
  );

  return {
    getDeviceCarrierLabel,
  };
}